import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route} from 'react-router-dom'
import WebFont from 'webfontloader';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import registerServiceWorker from './registerServiceWorker';

import RequireAuth from './controllers/AuthController';

import DashboardController from './controllers/DashboardController';
import NoteController from './controllers/NoteController';
import PostController from './controllers/PostController';
import QuotesController from './controllers/QuotesController';
import PostsController from './controllers/PostsController';
import WriteController from './controllers/WriteController';

const Routes = () => (
  <Router>
    <div>
      <Route exact path="/" component={RequireAuth(DashboardController)}/>
      <Route exact path="/inbox" component={RequireAuth(DashboardController, {mode: 'inbox'})}/>
      <Route exact path="/incoming-ocr" component={RequireAuth(DashboardController, {mode: 'ocr'})}/>
      <Route exact path="/notes" component={RequireAuth(DashboardController, {mode: 'notes'})}/>
      <Route exact path="/quotes" component={RequireAuth(QuotesController)} />
      <Route exact path="/posts" component={RequireAuth(PostsController)} />
      <Route exact path="/post/:id" component={RequireAuth(PostController)} />
      <Route exact path="/write" component={RequireAuth(WriteController)} />
      <Route exact path="/write/:id" component={RequireAuth(WriteController)} />
      <Route exact path="/note/:noteId" component={RequireAuth(NoteController)} />
      <Route exact path="/collection/:collectionId" component={RequireAuth(DashboardController)} />
      <Route exact path="/collection/:collectionId/write" component={RequireAuth(WriteController)} />
    </div>
  </Router>
);


WebFont.load({
  google: {
    families: ['Forum', 'Old Standard TT', 'Roboto', 'Roboto Mono']
  }
});

ReactDOM.render(<Routes />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js